import React from 'react';
import s from './style.module.css';
import logo from '@Images/logo.webp';
// import { useEffect } from 'react';
import { URL } from '@Pages/url';
// import { CTA_HIDDEN_PAGES } from '@Pages/setting';
import LazyableImage from '@Components/lazyable_image/view';
// import { isBusinessTime } from '@Util/util';
// import FreedialSVGIcon from '@Components/svg_icon/freedial';

export const Footer = () => {
    // const ref = React.useRef<HTMLDivElement>();
    const footerRef = React.useRef<HTMLDivElement>();
    const footerContentRef = React.useRef<HTMLDivElement>();
    // const currentPage = window.location.pathname;

    // const currentPosition = 0;
    // const timer = false;

    // if (!CTA_HIDDEN_PAGES.includes(currentPage) && isBusinessTime()) {
    //     const controlFooter = () => {
    //         if (!footerRef.current) return;

    //         const footerTop = footerRef.current.offsetTop;
    //         const contentHeight = footerContentRef.current.clientHeight;

    //         if (timer !== false) clearTimeout(timer);

    //         // 最後までスクロールした場合
    //         if (window.scrollY + window.innerHeight > footerTop + contentHeight) {
    //             ref.current.style.position = 'relative';
    //             ref.current.style.display = 'block';
    //         } else {
    //             ref.current.style.position = 'fixed';

    //             if (currentPosition < window.scrollY) ref.current.style.display = 'none';
    //             else ref.current.style.display = 'block';
    //         }

    //         timer = setTimeout(() => {
    //             ref.current.style.display = 'block';
    //         }, 500);

    //         currentPosition = window.scrollY;
    //     };
    //     useEffect(() => {
    //         window.addEventListener('scroll', controlFooter);
    //         return () => window.removeEventListener('scroll', controlFooter);
    //     }, []);
    // }
    return (
        <footer ref={footerRef} className={s.footer}>
            <div ref={footerContentRef} className={s.footer_component}>
                <LazyableImage src={logo} alt='住地ゴルフ' width={250} height={36} />
                <div className={s.footer_link}>
                    <ul>
                        <li>
                            <a href={URL.COMPANY}>会社情報</a>
                        </li>
                        <li>
                            <a href={URL.SITEPOLICY}>サイトポリシー</a>
                        </li>
                        <li>
                            <a href={URL.PRIVACY}>プライバシーポリシー</a>
                        </li>
                        <li>
                            <a href={URL.SITEMAP}>サイトマップ</a>
                        </li>
                    </ul>
                </div>
            </div>
            {/* {!CTA_HIDDEN_PAGES.includes(currentPage) && isBusinessTime() && (
                <div ref={ref} className={s.footer_tel_box}>
                    <span className={s.footer_tel_text}>お電話でのお問合せ</span>
                    <a className={s.footer_tel_main} href='tel:0120-18-0072'>
                        <FreedialSVGIcon bg_fill='#fff' front_fill='#000' /> 0120-18-0072
                    </a>
                </div>
            )} */}
            <div className={s.copyright}>Copyright &copy; juchi. All right reserved.</div>
        </footer>
    );
};
